<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditHarbor',
  props: {
    rowId: { type: [String, Number], default: null },
  },
  components: { Multiselect },
  data() {
    return {
      rowIdC: this.rowId,
      loadingData: false,
      name: '',
      displayName: null,
      variations: [''],
      code: null,
      coordinates: null,
      country: { id: null, name: null },
      countries: [],
    }
  },
  computed: {
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    fetchData() {
      this.loadingData = true
      axiosGetPost('get', '/cargofive/harbors/edit/' + this.rowIdC).then(
        (response) => {
          console.log(response)
          if (response.status) {
            let data = response.data
            this.name = data.name
            this.displayName = data.display_name
            this.code = data.code
            this.coordinates = data.coordinates
            this.country = data.country_id
            this.countries = data.countries
            this.variations = data.variations
          } else {
            this.$toastr.e('Attention. Error ' + response.message)
          }
          this.loadingData = false
          return response
        }
      )
    },
    validateFields() {
      const values = ['name', 'displayName', 'code']
      let bool = true
      values.forEach((element) => {
        if (!this[element]) {
          this.$toastr.e('Attention. Fill all fields ' + element)
          bool = false
        }
      })
      if (!this.variations.every((element) => element)) {
        this.$toastr.e('Attention. Fill all fields on variations')
        bool = false
      }
      if (this.country.id == null) {
        this.$toastr.e('Attention. Select a country')
        bool = false
      }
      return bool
    },
    newElement(variable) {
      let data = variable == 'variations' ? null : [null, null]
      this[variable].push(data)
      console.log(this.variations)
    },
    dropElement(index, variable) {
      this[variable].splice(index, 1)
      console.log(this.variations)
    },
    save() {
      if (this.validateFields()) {
        this.loadingData = true
        axiosGetPost('post', '/cargofive/harbors/edit/' + this.rowIdC, {
          name: this.name,
          display_name: this.displayName,
          code: this.code,
          coordinates: this.coordinates,
          country: this.country,
          variations: this.variations,
        }).then((response) => {
          //console.log(response)
          if (response.success) {
            this.$toastr.s('Success. Harbor updated')
          } else {
            this.$toastr.e('Attention. Error' + response.message)
          }
          this.loadingData = false
          this.$emit('update_view')
          this.$emit('close_modal')
          return response
        })
      }
    },
  },
}
</script>
<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group w-100">
        <div class="col-md-12 row">
          <div class="col-md-6">
            <label class="mb-1 mt-0" for="name-name">Name </label>
            <b-form-input
              :id="'name-name'"
              v-model="name"
              value
              @change="name_field"
              :placeholder="'Write value name'"
            ></b-form-input>
          </div>
          <div class="col-md-6">
            <label class="mb-1 mt-0" for="name-display">Display Name </label>
            <b-form-input
              :id="'name-display'"
              v-model="displayName"
              value
              :placeholder="'Write value Display Name'"
            ></b-form-input>
          </div>
        </div>

        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="name-code">Code </label>
            <b-form-input
              :id="'name-code'"
              v-model="code"
              value
              :placeholder="'Write value code'"
            ></b-form-input>
          </div>
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="name-coordinates">Coordinates </label>
            <b-form-input
              :id="'name-coordinates'"
              v-model="coordinates"
              value
              :placeholder="'Write value Coordinates'"
            ></b-form-input>
          </div>
          <div class="col-md-4">
            <label class="mb-1" for="default">Country </label>
            <multiselect
              v-model="country"
              :options="countries"
              placeholder="Select one "
              label="name"
              track-by="name"
            ></multiselect>
          </div>
        </div>

        <div class="col-md-12 row">
          <div class="col-md-4">
            <label class="mb-1 mt-0" for="default"> Variations</label>
          </div>
        </div>
        <div class="col-md-12 row">
          <div
            class="col-md-4"
            v-for="(v, index) in variations"
            v-bind:key="index"
          >
            <div class="input-group mb-3">
              <b-form-input
                v-model="variations[index]"
                value
                :placeholder="'Write value '"
                class="form-control"
              ></b-form-input>
              <div
                class="input-group-prepend"
                @click="dropElement(index, 'variations')"
              >
                <span class="input-group-text">x</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-sm my-4 mt-0 btn-outline-secondary form-control"
            title="New variation"
            @click="newElement('variations')"
          >
            <i class="uil uil-plus"></i>
          </button>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-12">
            <b-button
              variant="primary"
              class="form-control col-md-4"
              @click="save()"
              >Updated</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>